import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getCardsConfigs() {
    return {
        custom: {
            [PALETTE_IDS.EVENT_CARDS]: {
                SelectionCard: {
                    selectionButton: {
                        view: {
                            width: 70,
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.EVENT_CARDS]: {
                CARD_BORDER_RADIUS: 8,
                CARD_BASE_HEADER_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_FALLBACK_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_MARKET_NAME_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_WATERMARK_ICON_COLOR: COLOR.RESERVED.WHITE,

                CARD_SELECTION_PRICE_BOOST_CONTAINER_BG: COLOR.RESERVED.BLUE1,
                CARD_SELECTION_PRICE_BOOST_ITEM: {
                    PBI_PREVIOUS_PRICE_HEADER_TEXT: COLOR.BRAND.FOREGROUND5,
                    PBI_PREVIOUS_PRICE_CVI: {
                        CVI_PREVIOUS_VALUE_TEXT: COLOR.BRAND.FOREGROUND5,
                    },
                },
                CARD_SELECTION_PRICE_BOOST_LABEL: {
                    PRICE_BOOST_LABEL_TEXT: {
                        fontSize: FONT.SIZE_XSMALL,
                    },
                },
            },
        },
    };
}
